const artistsWishlistIT = {
    "view": {
        "table": {
            "title": "La tua lista dei desideri degli artisti",
            "column": {
                "artist_name": "Nome dell'artista",
                "spotify_id": "ID Spotify",
                "followers": "Follower",
                "popularity": "Popolarità (%)",
                "action": "Azione"
            },
            "dropdown": {
                "action": "Azione",
                "addAsArtist": "Aggiungi come Artista",
                "delete": "Elimina"
            },
            "button": {
                "export_csv": "Esporta CSV"
            },
            "placeholder": {
                "search": "Cerca..."
            },
            "message": {
                "error": "Qualcosa è andato storto! Si prega di aggiornare la pagina e riprovare!"
            }
        },
        "modal": {
            "removeArtist": {
                "header": "Rimuovi l'artista {{artistName}} dalla lista dei desideri",
                "body": "Sei sicuro di voler rimuovere l'artista {{artistName}} dalla tua lista dei desideri?"
            }
        },
        "message": {
            "subscriptionUpgrade": "Il tuo attuale piano di abbonamento non supporta questa funzione. Si prega di <1>aggiornare</1> il piano di abbonamento per usufruire di questa funzione.",
            "subscriptionExpired": "Il tuo abbonamento è scaduto. Si prega di <1>riprendere</1> l'abbonamento per usufruire di questa funzione.",
            "noAccess": "Non hai accesso a questo modulo, contatta il team di supporto per ulteriori informazioni."
        }
    }
};

export default artistsWishlistIT;